export default __webpack_public_path__ + "static/media/banner-image.a6246a26.svg";